import { ExclamationCircleFilled } from '@ant-design/icons';
import { message, Switch } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { getUserName } from '@/infrastructure/auth';
import { BusiCode } from '@/infrastructure/axios/code';
import {
  ConfigTabType,
  FullConfig,
  isConfigManage,
  setEnable,
} from '@/presentation/pages/setting/app-deliver-config/api';
import { ConfirmModal } from '@/presentation/pages/setting/app-deliver-config/config-modal/confirm';

interface IProps {
  tab: ConfigTabType;
  data: FullConfig;
  update: () => void;
}

export const ConfigSwitch: FC<IProps> = (props) => {
  const { tab, data, update } = props;
  const { enabled, auth, id } = data;
  const [visible, setVisible] = useState(false);
  const [checked, setChecked] = useState<boolean>(enabled === 1);
  const [confirmTitle, setConfirmTitle] = useState<string>('');
  const [confirmPrompt, setConfirmPrompt] = useState<string>('');
  const key = 'ConfigSwitch';

  const onOk = async () => {
    const loadingMessageHide = message.loading({ content: '请求中...', key });
    setVisible(false);

    const reqData = await setEnable(
      tab,
      id,
      !checked ? 1 : 0,
      getUserName(),
    );

    if (reqData?.baseRsp?.code === BusiCode.Ok) {
      setChecked(!checked);
      loadingMessageHide();
      update();
    }
  };

  const onCancel = () => {
    setVisible(false);
  };

  const onClick = async (_data: boolean) => {
    if (!checked) {
      setConfirmTitle('确认开启所选配置？');
      setConfirmPrompt('配置开启后立即生效，请检查配置内容确认无误后开启。');
    } else {
      setConfirmTitle('确认关闭所选配置？');
      setConfirmPrompt('关闭后用户将拉不到相关配置，请确认是否关闭。');
    }
    setVisible(true);
  };

  useEffect(() => {
    setChecked(!!enabled);
  }, [enabled]);

  return (
    <>
      <Switch disabled={!auth && !isConfigManage(tab)} checked={checked} onClick={onClick}/>
      <ConfirmModal
        visible={visible}
        icon={<ExclamationCircleFilled style={{ fontSize: '21px', color: '#F28B24' }} />}
        onOk={onOk}
        onCancel={onCancel}
        confirmTitle={confirmTitle}
        confirmPrompt={confirmPrompt}
      />
    </>
  );
};
